import { LocalizationService } from './localization.service';

export default angular
  .module('sfMobile.services.localization', [])
  .service('localizationService', LocalizationService).name;
